export type FeatureFlagType = {
  DISABLED_UNLOCK_WHEN_CHECKED_IN?: boolean;
  MEMBER_APP_CHECK_IN?: boolean;
  PORTAL_XERO?: boolean;
  ONBOARDING_FLOW?: boolean;
  NEW_MEMBERS_APP_HOME?: boolean;
  FE_STAFF_NEW_ENDPOINTS_RSVP?: boolean;
  FE_MEMBER_NEW_ENDPOINTS_RSVP?: boolean;
  NEW_MEMBERS_APP_ACCESS?: boolean;
  PORTAL_LATE_PAYMENT_FEE_RECURRING_MEMBERSHIP?: boolean;
  NEW_MEMBERS_APP_PROFILE_TAB?: boolean;
  PORTAL_NEW_STAFF_SIDEBAR?: boolean;
};

const globalFeatureFlagOverride: FeatureFlagType = {
  NEW_MEMBERS_APP_HOME: true,
  NEW_MEMBERS_APP_ACCESS: true,
  NEW_MEMBERS_APP_PROFILE_TAB: false,
};

export const featureFlagOverrideMap = {
  portal: globalFeatureFlagOverride,
  memberApp: globalFeatureFlagOverride,
  staffApp: globalFeatureFlagOverride,
} as const;
